import moment from "moment";
import { time_unit_info, time_range_std, timeSpace } from "./common";

function getBoundary(map, city) {
  var bdary = new BMap.Boundary();
  bdary.get(city, function(rs) {
    //for循环都删除掉了，只剩下这个
    //网上查了下，东西经南北纬的范围
    var EN_JW = "180, 90;"; //东北角
    var NW_JW = "-180,  90;"; //西北角
    var WS_JW = "-180, -90;"; //西南角
    var SE_JW = "180, -90;"; //东南角
    //4.添加环形遮罩层
    var ply1 = new BMap.Polygon(
      rs.boundaries[0] + SE_JW + SE_JW + WS_JW + NW_JW + EN_JW + SE_JW,
      {
        strokeColor: "none",
        fillColor: "#081734",
        fillOpacity: 1,
        strokeOpacity: 0.5
      }
    ); //建立多边形覆盖物

    map.addOverlay(ply1);
    //5. 给目标行政区划添加边框，其实就是给目标行政区划添加一个没有填充物的遮罩层
    var ply = new BMap.Polygon(rs.boundaries[0], {
      strokeWeight: 2,
      strokeColor: "#00f",
      fillColor: ""
    });
    map.addOverlay(ply);
    // map.setViewport(ply.getPath());    //调整视野
  });
}

function drawBoundary(map, city) {
  var bdary = new BMap.Boundary();
  bdary.get(city, function(rs) {
    //获取行政区域
    var count = rs.boundaries.length; //行政区域的点有多少个
    if (count === 0) {
      console.log("未能获取当前输入行政区域");
      return;
    }
    var pointArray = [];
    for (var i = 0; i < count; i++) {
      var ply = new BMap.Polygon(rs.boundaries[i], {
        strokeWeight: 2,
        strokeColor: "rgba(255,255,255,0.9)",
        fillColor: ""
      }); //建立多边形覆盖物
      map.addOverlay(ply); //添加覆盖物
    }
  });
}

function drawTile({
  map,
  draw_value,
  group_id,
  time,
  timeType,
  colormap_dyn_type,
  p_num_min,
  min,
  max,
  fileName,
  fileName_flag,
  baseUrl = "",
  radiusPixel
}) {
  var tileLayer = new BMap.TileLayer();
  if (colormap_dyn_type != "dynamic") {
    colormap_dyn_type = "static";
  }
  tileLayer.getTilesUrl = function(tileCoord, zoom) {
    var x = tileCoord.x;
    var y = tileCoord.y;
    if (fileName_flag) {
      var str =
        "9999/file_name/" +
        fileName +
        "/bd09?" +
        "x=" +
        x +
        "&y=" +
        y +
        "&z=" +
        zoom +
        "&draw_value=" +
        draw_value +
        `&p_num_min=${p_num_min}&colormap_dyn_type=` +
        colormap_dyn_type +
        "&route_only_point=ALLPOINT&draw_point=1&draw_line=0";
    } else {
      var str =
        group_id +
        "/" +
        timeType +
        "/" +
        time +
        "/bd09?" +
        "x=" +
        x +
        "&y=" +
        y +
        "&z=" +
        zoom +
        "&draw_value=" +
        draw_value +
        `&p_num_min=${p_num_min}&colormap_dyn_type=` +
        colormap_dyn_type +
        "&route_only_point=ALLPOINT&draw_point=1&draw_line=0";
    }
    var url = `/api/car_api_py/car_summary_get_api/get_summary_tile/` + str;
    if (min || (max && colormap_dyn_type != "stair")) {
      url += `&colormap_min=${min}&colormap_max=${max}`;
    } else {
      url += `&colormap_min=0&colormap_max=700`;
    }
    if (radiusPixel) {
      url += `&radius_pixel=${radiusPixel}`;
    }
    if (baseUrl) {
      url = `http://${baseUrl}${url}`;
    }
    return url;
  }.bind(this);
  map.addTileLayer(tileLayer);
  return tileLayer;
}

function drawTileWidthUrl(
  map,
  url,
  draw_value,
  time,
  timeType,
  colormap_dyn_type,
  p_num_min,
  min,
  max
) {
  var tileLayer = new BMap.TileLayer();
  tileLayer.getTilesUrl = function(tileCoord, zoom) {
    var x = tileCoord.x;
    var y = tileCoord.y;
    var str =
      url +
      "/" +
      timeType +
      "/" +
      time +
      "/bd09?" +
      "x=" +
      x +
      "&y=" +
      y +
      "&z=" +
      zoom +
      "&draw_value=" +
      draw_value +
      `&p_num_min=${p_num_min}&colormap_dyn_type=` +
      colormap_dyn_type +
      "&route_only_point=ALLPOINT&draw_point=1&draw_line=0";
    if (min || (max && colormap_dyn_type != "stair")) {
      str += `&colormap_min=${min}&colormap_max=${max}`;
    } else {
      str += `&colormap_min=0&colormap_max=700`;
    }
    return str;
  }.bind(this);
  map.addTileLayer(tileLayer);
  return tileLayer;
}

function GetQueryString(name) {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  var r = window.location.search.substr(1).match(reg);
  if (r != null) return unescape(r[2]);
  return null;
}

function getByteLen(str) {
  var len = 0;
  for (var i = 0; i < str.length; i++) {
    var ch = str.charCodeAt(i);
    if (ch >= 0 && ch <= 128) {
      len += 1;
    } else {
      len += 2;
    }
  }
  return len;
}

function addMarker({
  map,
  info,
  title,
  showTitle,
  value,
  drawCircle,
  circleR,
  icon,
  intensity,
  bgcolorDefault,
  fgcolorDefault,
  coord,
  showValue = true,
  clickCallBack
}) {
  var val = value;
  let bg_color;
  let fgcolor;
  if (bgcolorDefault) {
    bg_color = bgcolorDefault;
  } else {
    bg_color = intensity.bgcolor.getColor(val);
  }
  if (fgcolorDefault) {
    fgcolor = fgcolorDefault;
  } else {
    fgcolor = intensity.fgcolor.getColor(val);
  }
  if (!val || val == "--") {
    val = "--";
    bg_color = "grey";
  } else {
    val = Math.round(val);
  }
  var text = "污染贡献值";
  if (info.index) {
    text += info.index;
  }
  var name = "";
  if (showTitle) {
    name = title;
  }
  if (showValue) {
    text += " " + val;
  }

  var width = getByteLen(text) * 6 - 8;
  if (width > 10) {
    width = width + 80;
  } else {
    width = 60;
  }
  var arrow_left = width / 2 - 5;

  var htm =
    "<div style='position: absolute;z-index:100;border-radius: 5px;border: 2px solid " +
    "black" +
    "; color: white;transform:translate(-50%,-50%);bottom:5px;width:" +
    width +
    "px' >" +
    "<div style='background-color:" +
    bg_color +
    ";text-align: center;padding: 0px 2px; margin: 0px; height: 20px; border-radius: 2px;color:" +
    fgcolor +
    "'>" +
    // icon +
    "<span style='display:inline-block;" +
    "color:" +
    fgcolor +
    "'>" +
    text +
    "</span></div>" +
    "<div class='arrow'" +
    " style=\"background: url('http://iot.novaecs.com/f/v1/img/bdmap/label.png') 0px 0px no-repeat; position: absolute; width:6px; height: 15px; top: 22px; left: " +
    arrow_left +
    'px; overflow: hidden;">';
  "</div>" + "</div>";
  var p;
  if (coord == "wgs84") {
    let gcj = coordtransform.wgs84togcj02(info.lng, info.lat);
    let bd = coordtransform.gcj02tobd09(gcj[0], gcj[1]);
    p = new BMap.Point(bd[0], bd[1]);
  } else {
    p = new BMap.Point(info.Lng, info.Lat);
  }
  var marker = new BMapLib.RichMarker(htm, p, {
    zIndex: 100
  });
  // var marker = new BMap.Marker(p);
  // marker.setZIndex(10)
  if (drawCircle) {
    var circleMarker = new BMap.Circle(p, circleR, {
      fillOpacity: 0.001,
      strokeWeight: 3,
      strokeColor: bg_color
    });
    map.addOverlay(circleMarker);
    marker.circleMarker = circleMarker;
  }
  if (clickCallBack) {
    marker.addEventListener("click", e => {
      clickCallBack(map, e.currentTarget.info);
    });
  }
  marker.info = info;
  map.addOverlay(marker);
  return marker;
}

function addTextMarker({ map, text, info, coord }) {
  var htm = `<span style="position: absolute; color: white; transform: translate(-50%, 0); background: transparent; display: block; width: 40px; font-size: 12px; text-align:center">${text}</span>`;
  var p;
  if (coord == "wgs84") {
    let gcj = coordtransform.wgs84togcj02(info.lng, info.lat);
    let bd = coordtransform.gcj02tobd09(gcj[0], gcj[1]);
    p = new BMap.Point(bd[0], bd[1]);
  } else {
    p = new BMap.Point(info.Lng, info.Lat);
  }
  var marker = new BMapLib.RichMarker(htm, p, {
    zIndex: 100
  });
  map.addOverlay(marker);
  return marker;
}

function addFlagMarker(map, WRJData) {
  var markers = [];
  var data = WRJData.data;
  var latIndex = WRJData.fields.indexOf("lat");
  var lngIndex = WRJData.fields.indexOf("lng");
  for (var i of data) {
    let lat = i[latIndex];
    let lng = i[lngIndex];
    try {
      let gcj = coordtransform.wgs84togcj02(lng, lat);
      let bd = coordtransform.gcj02tobd09(gcj[0], gcj[1]);
      var p = new BMap.Point(bd[0], bd[1]);
      // var icon = new BMap.Icon(require('../assets/icon/333.png'), new BMap.Size(60, 100))
      var icon = "";
      var marker = new BMap.Marker(p, {
        icon: icon
      });
      marker.setZIndex(100);
      marker.addEventListener("mousedown", function(e) {
        // e.stopPropagation()
      });
      markers.push(marker);
    } catch (e) {
      console.log(e);
    }
  }
  var markerClusterer = new BMapLib.MarkerClusterer(map, {
    markers: markers
  });
  return markerClusterer;
}

function hexToRgba(hex, opacity) {
  return (
    "rgba(" +
    parseInt("0x" + hex.slice(1, 3)) +
    "," +
    parseInt("0x" + hex.slice(3, 5)) +
    "," +
    parseInt("0x" + hex.slice(5, 7)) +
    "," +
    opacity +
    ")"
  );
}

function month_to_time_delta(month_title, month_type_list) {
  if (!month_title) {
    return;
  }

  let month_t_list = month_title.split(":");
  let month_time = moment(month_t_list[1]);
  let t_start = _.cloneDeep(month_time);
  let t_end = _.cloneDeep(month_time);
  let days = 1;
  let format = "YYYY-MM-DD 00:00:00";
  if (month_t_list[0] == "日叠加" || month_t_list[0] == "day") {
    t_end.add(1, "days");
  }
  if (
    month_t_list[0] == "周叠加" ||
    month_t_list[0] == "week" ||
    month_t_list[0] == "7天叠加"
  ) {
    t_end.add(1, "days");
    t_start.subtract(7, "days");
    days = 7;
  }
  if (month_t_list[0] == "10天叠加") {
    t_end.add(1, "days");
    t_start.subtract(10, "days");
    days = 10;
  }
  if (
    month_t_list[0] == "月叠加" ||
    month_t_list[0] == "month" ||
    month_t_list[0] == "30天叠加"
  ) {
    t_end.add(1, "days");
    t_start.subtract(30, "days");
    days = 30;
  }
  if (month_t_list[0] == "90天叠加") {
    t_end.add(1, "days");
    t_start.subtract(90, "days");
    days = 90;
  }
  if (month_t_list[0] == "当月叠加" || month_t_list[0] == "cmonth") {
    t_start.startOf("month");
    t_end.add(1, "days");
    days = month_time.format("DD") - 0;
  }
  if (month_t_list[0] == "1小时叠加" || month_t_list[0] == "hour") {
    t_start.subtract(1, "hours");
    format = "YYYY-MM-DD HH:00:00";
  }
  if (month_t_list[0] == "12小时叠加" || month_t_list[0] == "c24hour") {
    t_start.subtract(12, "hours");
    format = "YYYY-MM-DD HH:00:00";
  }
  if (month_t_list[0] == "24小时叠加" || month_t_list[0] == "c24hour") {
    t_start.subtract(24, "hours");
    format = "YYYY-MM-DD HH:00:00";
  }
  if (
    month_t_list[0] == "上旬叠加" ||
    month_t_list[0] == "中旬叠加" ||
    month_t_list[0] == "下旬叠加" ||
    month_t_list[0] == "最近旬叠加"
  ) {
    days = 10;
  }
  if (month_type_list) {
    for (let item of month_type_list) {
      if (
        (item.name + "叠加" == month_t_list[0]) == "上旬叠加" &&
        month_t_list[0] == "当月叠加"
      ) {
        days = item.p_num_min;
      }
    }
  }

  if (t_start && t_end) {
    return {
      start: t_start.format(format),
      end: t_end.format(format),
      days: days
    };
  } else {
    return {};
  }
}

function get_last_month(month) {
  let month_time = month_to_time_delta(month);
  let month_split = month.split(":");
  let t = moment(month_time.start)
    .subtract(0, "days")
    .format("YYYY-MM-DD HH:00:00");
  if (month_split[0] == "日叠加") {
    t = moment(month_time.start)
      .subtract(1, "days")
      .format("YYYY-MM-DD HH:00:00");
  }
  let last_month =
    month_split[0] + ":" + t + ":" + month_split[month_split.length - 1];
  return last_month;
}

var colorcache = {};
function getgradientcolor(value, type) {
  var v = parseInt(value);
  if (colorcache[type] && colorcache[type][v]) {
    return colorcache[type][v];
  } else {
    if (!colorcache[type]) {
      colorcache[type] = {};
    }
    colorcache[type][v] = getgradientcolorInner(type, v);
    return colorcache[type][v];
  }
}

function getlevelcolor(level) {
  return _.find(pmcolors, x => {
    return x.level == level;
  });
}

function getgradientcolorInner(type, value) {
  let color_info = getPMInfo(value, type);

  let stopColor = color_info.bgcolor;
  let level = color_info.level;
  if (level == 0 || level == 1) {
    return stopColor;
  }
  if (value >= 700) {
    return stopColor;
  }
  value = parseInt(value);
  let [stopR, stopG, stopB] = colorRgb(stopColor);

  let startColor = getlevelcolor(level - 1);
  let [startR, startG, startB] = colorRgb(startColor.bgcolor); //转换为rgb数组模式
  let lastlevelValue = startColor["highval_" + type];
  let nextLevelValue = color_info["highval_" + type];
  let o = (value - lastlevelValue) / (nextLevelValue - lastlevelValue);
  let sR = (stopR - startR) * o; //总差值
  let sG = (stopG - startG) * o;
  let sB = (stopB - startB) * o;
  return colorHex(
    "rgb" +
      parseInt(sR + startR) +
      "," +
      parseInt(sG + startG) +
      "," +
      parseInt(sB + startB) +
      ""
  );
}

function colorHex(rgb) {
  var _this = rgb;
  var reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;
  if (/^(rgb|RGB)/.test(_this)) {
    var aColor = _this.replace(/(?:(|)|rgb|RGB)*/g, "").split(",");
    var strHex = "#";
    for (var i = 0; i < aColor.length; i++) {
      var hex = Number(aColor[i]).toString(16);
      hex = Number(aColor[i]) < 16 ? 0 + "" + hex : hex; // 保证每个rgb的值为2位
      if (hex === "0") {
        hex += hex;
      }
      strHex += hex;
    }
    if (strHex.length !== 7) {
      strHex = _this;
    }
    return strHex;
  } else if (reg.test(_this)) {
    var aNum = _this.replace(/#/, "").split("");
    if (aNum.length === 6) {
      return _this;
    } else if (aNum.length === 3) {
      var numHex = "#";
      for (var i = 0; i < aNum.length; i += 1) {
        numHex += aNum[i] + aNum[i];
      }
      return numHex;
    }
  } else {
    return _this;
  }
}

function colorRgb(sColor) {
  var reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;
  var sColor = sColor.toLowerCase();
  if (sColor && reg.test(sColor)) {
    if (sColor.length === 4) {
      var sColorNew = "#";
      for (var i = 1; i < 4; i += 1) {
        sColorNew += sColor.slice(i, i + 1).concat(sColor.slice(i, i + 1));
      }
      sColor = sColorNew;
    }
    //处理六位的颜色值
    var sColorChange = [];
    for (var i = 1; i < 7; i += 2) {
      sColorChange.push(parseInt("0x" + sColor.slice(i, i + 2)));
    }
    return sColorChange;
  } else {
    return sColor;
  }
}

function check_time_range(start, end, time_type) {
  if (time_type == "real") {
    time_type = "min";
  }
  let time_unit = time_unit_info[time_type];
  let max_range = timeSpace[time_type];
  let current_tange = (end - start) / 1000;
  let point_counts = (end - start) / 1000 / time_unit;
  let point_counts_min = 4;
  let point_counts_max = 2880;
  if (current_tange > max_range) {
    end = start + max_range * 1000 + 1000;
  }
  if (point_counts < point_counts_min) {
    end = start + time_unit * point_counts_min * 1000 + 1000;
  }
  let t_now = Date.parse(new Date());
  if (end > t_now) {
    end = t_now;
    start = end - time_unit * point_counts_min * 1000;
  }
  console.log(point_counts);
  return { start: start, end: end };
}

function getWindDirectionDesc(degree) {
  if (degree || degree === 0) {
    let descs = ["东", "东南", "南", "西南", "西", "西北", "北", "东北"];
    let index = Math.floor((degree + 22.5) / 45) % 8;
    // console.log(descs[index], degree);
    return descs[index];
  } else {
    return "";
  }
}

function GetRequest(name) {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  // var r = window.location.search.substr(1).match(reg);
  var r = window.location.search.slice(1).match(reg);
  if (r != null) {
    // return unescape(r[2]);
    return decodeURI(r[2]);
  }
  return null;
}

export {
  GetQueryString,
  getBoundary,
  drawBoundary,
  drawTile,
  addMarker,
  hexToRgba,
  month_to_time_delta,
  get_last_month,
  getgradientcolor,
  drawTileWidthUrl,
  addFlagMarker,
  check_time_range,
  getWindDirectionDesc,
  addTextMarker,
  GetRequest
};
